import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { TextButton } from './TextButton';
import { smsMessages } from '../utils/sms';
interface TextCtaProps {
  title?: string;
  lede?: string;
}
export function TextCta({
  title = 'Text us. A specialist answers, not a bot.',
  lede = 'Send your pool size or a photo of your equipment pad and we will tell you which system fits, what it costs, and when it can be installed.'
}: TextCtaProps) {
  return <section className="bg-ink-950 py-20 lg:py-28" data-id="element-242" data-mp="2gao5k1nq1o63">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-243" data-mp="2k93pfwoiagfa">
        <div className="grid gap-12 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-20" data-id="element-244" data-mp="26irw5ug6qbmk">
          <div data-id="element-245" data-mp="26gxk75mw5tum">
            <p className="mb-4 text-xs uppercase tracking-[0.18em] text-aqua-300" data-id="element-246" data-mp="2bhlatq77k8ob">
              Talk to us
            </p>
            <h2 className="max-w-xl font-display text-3xl font-semibold leading-[1.08] tracking-tightest text-white sm:text-4xl lg:text-[46px]" data-id="element-247" data-mp="2z75ygmeb3u3x">
              {title}
            </h2>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-white/60" data-id="element-248" data-mp="2f0zj0zhku4h4">
              {lede}
            </p>
            <div className="mt-9" data-id="element-249" data-mp="2b0xhqrfr7d2d">
              <TextButton message={smsMessages.quote} variant="onDark" size="lg" data-id="element-250" data-mp="2axt4l4kb96zk">
                Text us
              </TextButton>
            </div>
          </div>

          <div className="rounded-2xl bg-white/5 p-6 ring-1 ring-white/10 sm:p-8" data-id="element-251" data-mp="2yp8b79j4eagm">
            <div className="flex items-center gap-3 text-white" data-id="element-252" data-mp="2yrbdarxjru1p">
              <MessageSquareIcon className="h-5 w-5 text-aqua-300" aria-hidden="true" data-id="element-253" data-mp="2tpvoqpw5v5ek" />
              <span className="font-display text-lg font-medium" data-id="element-254" data-mp="37ovek0vetqcb">
                How texting works
              </span>
            </div>
            <ul className="mt-6 space-y-4 text-sm text-white/65" data-id="element-255" data-mp="32p90xqbo682z">
              <li className="flex gap-3" data-id="element-256" data-mp="1dcx7a4gnv4j2">
                <span className="text-aqua-300" data-id="element-257" data-mp="18d2e1u9ey2uu">01</span>
                Tap any text button &mdash; your message opens pre-written.
              </li>
              <li className="flex gap-3" data-id="element-258" data-mp="38glogdqobpnl">
                <span className="text-aqua-300" data-id="element-259" data-mp="38hmyqfzv8849">02</span>
                Hit send. Most replies land within minutes during business hours.
              </li>
              <li className="flex gap-3" data-id="element-260" data-mp="3icosxq9000dp">
                <span className="text-aqua-300" data-id="element-261" data-mp="3mf39g3p72o1t">03</span>
                We size, quote and schedule your install over text.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}